import { Input as AntdInput } from 'antd'
import { SearchProps } from 'antd/es/input'
import styled from 'styled-components'

const { Search: AntdSearch } = AntdInput

const SearchStyled = styled(AntdSearch)`
  input {
    height: 32px;
  }
`

const Search = (props: SearchProps) => <SearchStyled {...props} />

export default Search
